module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMzY5NjI5IDIwLjYxMDJMMTIuMzY5NiAwLjAxMjQ1MTJMMjQuNDYxNiAyMC42MTAyTDIxLjAxMzMgMjQuMDEyNUwxNC4yNTQ3IDE5LjA0NjlIMTguNjY4NUwxMi4zNjk2IDguNzQ4MDhMNi4xMTY3NiAxOS4wNDY5SDEwLjU3NjVMMy43NzE5MyAyNC4wMTI1TDAuMzY5NjI5IDIwLjYxMDJaIiBmaWxsPSIjNzU3NTc1Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/games/games_grey/apex.svg
// module id = 47RK
// module chunks = 35